export default __webpack_public_path__ + "static/media/gallery_08.9c80d88d.jpg";